var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pie-chart',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions,"plugins":_vm.chartPlugins},on:{"chart:render":_vm.onChartRender}})}
var staticRenderFns = []

export { render, staticRenderFns }